import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { atLeastOneDaySelectedValidator } from '../../employees/add-employees/add-employees.component';
import { Suggestion, SuggestionInputComponent } from 'src/app/components/suggestion-input/suggestion-input.component';
import { Features } from '../../../interfaces/features';
import { Cars } from '../../../interfaces/cars';

@Component({
  selector: 'app-add-car',
  templateUrl: './add-car.component.html',
  styleUrl: './add-car.component.css'
})
export class AddCarComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  types:Suggestion[];
  brands:Suggestion[];

  ngOnInit(): void {
    if (this.storesId > 0) {
      this.form1.get('stores_id')?.setValue(this.storesId);
    }
    this.api.getAllFeaturesFilter(1).subscribe((response) => {
      var suggestion:Suggestion[]= SuggestionInputComponent.convertJsonASuggestion(response.data as Features[],['tag']);
      this.types = suggestion;
    }, e => {
      this.toast.warning(e.error.mistakes, e.error.msg);
    });
    this.api.getAllFeaturesFilter(2).subscribe((response) => {
      var suggestion:Suggestion[]= SuggestionInputComponent.convertJsonASuggestion(response.data as Features[],['tag']);
      this.brands = suggestion;
    }, e => {
      this.toast.warning(e.error.mistakes, e.error.msg);
    });
  }

  @Output()
  success = new EventEmitter<Cars>();

  @Input()
  storesId: number;
  form1: FormGroup = this.formBuilder.group({
    ppu: ['', Validators.required],
    type: ['', [Validators.required]],
    types_id:[134],
    brand: [''],
    brands_id: [0],
    model: [''],
    obs: [''],
    parking:[0],
    state_id:[1],
    stores_id: [0],
  });

  create() {
    this.api.createCars(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'VEHÍCULOS');
        var car=res.data as Cars;
        console.log("cars create:",car);
        this.success.emit(car);
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }


  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
